import React from "react";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import DepositInvoicePDF from "./DepositInvoicePDF";

const InvoicePopup = ({ deposit, user, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
            <div className="bg-white rounded-lg p-6 w-[90%] h-[90%] overflow-auto relative shadow-xl">
                <div className="flex justify-end mb-2 gap-10">
                    <div className="text-center mt-4">
                        <PDFDownloadLink
                            document={<DepositInvoicePDF deposit={deposit} user={user} />}
                            fileName={`deposit_invoice_${deposit.id}.pdf`}
                        >
                            {({ loading }) => (
                                <button
                                    className="bg-blue-600 hover:bg-blue-700 text-white rounded px-6 py-2 font-semibold text-base transition"
                                    disabled={loading}
                                >
                                    {loading ? "Đang tạo PDF..." : "Download PDF"}
                                </button>
                            )}
                        </PDFDownloadLink>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-4xl text-gray-400 hover:text-gray-700 font-bold bg-transparent border-none cursor-pointer"
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
                <div className="w-full h-full mb-6 border rounded overflow-hidden">
                    <PDFViewer width="100%" height="100%%">
                        <DepositInvoicePDF deposit={deposit} user={user} />
                    </PDFViewer>
                </div>
            </div>
        </div>
    );
};

export default InvoicePopup;
